module.exports = __webpack_public_path__ + "img/children-2.27cce01b.jpg";